
<template>
    <div class="OperateNavTable">
        <group :client="client" :list="Table[1]" :length="5" />
        <BoardFast :client="client" :group="TableAll" :step="true" />
    </div>
</template>

<script>
import CommonMix from '../common.js'
import Group from '../group.vue'
export default {
    name: 'OperateSyw2',
    mixins: [CommonMix],
    props: {
        client: {}
    },
    components: {
        Group
    }
}
</script>
